var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "14px",
    viewBox: "0 0 7 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Triangle Copy 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wires-V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GlidePath_-Sex-Copy",
    transform: "translate(-120.000000, -102.000000)",
    fill: "#79DD01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(120.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.85355339,3.85355339 L9.64644661,9.64644661 C9.84170876,9.84170876 9.84170876,10.1582912 9.64644661,10.3535534 C9.55267842,10.4473216 9.42550146,10.5 9.29289322,10.5 L-2.29289322,10.5 C-2.56903559,10.5 -2.79289322,10.2761424 -2.79289322,10 C-2.79289322,9.86739176 -2.7402148,9.7402148 -2.64644661,9.64644661 L3.14644661,3.85355339 C3.34170876,3.65829124 3.65829124,3.65829124 3.85355339,3.85355339 Z",
    id: "Triangle-Copy-6",
    transform: "translate(3.500000, 7.000000) rotate(-270.000000) translate(-3.500000, -7.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressTriangle);
export default __webpack_public_path__ + "static/media/progress-triangle.9857135b.svg";
export { ForwardRef as ReactComponent };